// frontend/modules/sms/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import SmsManagementView from './views/SmsManagementView';

export const smsRoutes: RouteObject[] = [
    {
        path: '/notifications/sms',
        element: <SmsManagementView />,
        errorElement: <ErrorBoundary />
    }
];